(function (angular) {
  angular.module('xplenty-designer').factory('DesignerCubeComponent', [
    'DesignerComponent',
    'DesignerSchema',

    function (DesignerComponent, DesignerSchema) {
      function DesignerCubeComponent() {
        DesignerComponent.apply(this);
      }

      DesignerCubeComponent.prototype = new DesignerComponent();

      DesignerCubeComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          grouped_fields: this.grouped_fields || this.defaults.grouped_fields,
          aggregated_fields: this.aggregated_fields || this.defaults.aggregated_fields,
        });

        return data;
      };

      DesignerCubeComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerCubeComponent.prototype.setData = function (data) {
        this.grouped_fields = data.grouped_fields;
        this.aggregated_fields = data.aggregated_fields;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerCubeComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();

        schema.id = this.id;
        schema.name = this.name;

        const groupedFields = _.flatten(_.pluck(this.grouped_fields, 'fields'));

        _.each(groupedFields, function (fieldName) {
          schema.fields.push({
            name: fieldName,
          });
        });

        _.each(this.aggregated_fields, function (field) {
          schema.fields.push({
            name: field.alias,
          });
        });

        return schema;
      };

      return DesignerCubeComponent;
    },
  ]);
})(window.angular);
